import React from 'react'
import { useDraggableSheet } from '../../../helpers/hooks';
import './AboutCreator.scss';
import { useNavigate } from 'react-router-dom';
import { getProfilePublicPath } from '../../../helpers/profilePaths';
import ProfilePicture from '../ProfilePicture/ProfilePicture';
import { getUserDisplayName } from '../../../helpers/userDisplayName';

const AboutCreator = ({ user, onClose }) => {
    const navigate = useNavigate();
    const {
        // dragOffset,
        // dragging,
        sheetStyle,
        overlayHandlers
    } = useDraggableSheet({ onClose });

    return (
        <div
            className="about-creator_profile "
            {...overlayHandlers}
        >
            <div
                className={`sheet_about_profile`}
                style={{ ...sheetStyle }}
                onClick={(e) => e.stopPropagation()}
                onTouchStart={(e) => e.stopPropagation()}
                onTouchMove={(e) => e.stopPropagation()}
                onTouchEnd={(e) => e.stopPropagation()}
            >
                <div className="about-creator-container_profile ml-24 mr-24 mt-24">
                    <ProfilePicture imgUrl={user?.profilePicture} width={72} height={72} no_edit={true} handleClick={() => {
                        const p = getProfilePublicPath(user);
                        if (p) navigate(p);
                    }} />
                    <p className="fs-sm2 fw-bold mt-24 mb-12">About {getUserDisplayName(user)}</p>
                    <p className="fg-dark fw-medium mb-0 mt-0 bio">{user?.bio || ""}</p>
                </div>
                <div className="btn-about-wrapper">
                    <button onClick={onClose} className='btn-about btn'>Close</button>
                </div>
            </div>
        </div>
    )
}

export default AboutCreator